import React, { createContext, useContext } from 'react';

export type InfoField = {
  labelKey: string;
  value: string | number | null | undefined;
  colWidth: number;
};

export type ModeButton = {
  labelKey: string;
  className: string;
  onClick?: () => void;
  isDisabled: boolean;
};

export interface OperatorTaskContextType {
  taskId: number | string;
  processName: string | null;
  processType: number | string | null;
  selectedTrayId: string | null;
  trayHistory: string[];
  isProcessStarted: boolean;
  activeSize: string;
  formattedTime: string;
  operatorCount: number;
  infoFields: InfoField[];
  buttons: ModeButton[];
  showKeepToolPopup?: boolean;
  handleKeepToolSave?: (keptToolNumbers: string[]) => void;
  handleKeepToolClose?: () => void;
  showAddTrayInput: boolean;
  trayId: string;
  setTrayId: (val: string) => void;
  addTray: () => void;
  handleBackClick: () => void;
  openLEDHandler: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  handleFontSizeChange: (size: any) => void;
  handleDecrement: () => void;
  handleIncrement: () => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleTraySelectChange: (tray: string) => void;
  shouldShowTrayWarning: (tray: string) => boolean;
  shouldShowCheckMark: (tray: string) => boolean;
  traySelectRef: React.RefObject<HTMLButtonElement>;
  showConfirmModal: boolean;
  isAddTrayInput?: boolean;
  setIsAddTrayInput?: (val: boolean) => void;
  openNonConformity?: boolean;
  setOpenNonConformity?: (val: boolean) => void;
  operatorResponseViewType?: number;
  viewProps?: any;
  isTimerRunning?: boolean;
  showDraggableStart?: boolean;
  setShowDraggableStart?: React.Dispatch<React.SetStateAction<boolean>>;
  handleSubmitNCWork?: (data?: any) => void | Promise<void>;
}

const OperatorTaskContext = createContext<OperatorTaskContextType | undefined>(
  undefined
);

export const OperatorTaskProvider: React.FC<{
  value: OperatorTaskContextType;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return (
    <OperatorTaskContext.Provider value={value}>
      {children}
    </OperatorTaskContext.Provider>
  );
};

export const useOperatorTaskContext = (): OperatorTaskContextType => {
  const context = useContext(OperatorTaskContext);
  if (!context) {
    throw new Error(
      'useOperatorTaskContext must be used within an OperatorTaskProvider'
    );
  }
  return context;
};

export default OperatorTaskContext;

